import { render, staticRenderFns } from "./Survey2.vue?vue&type=template&id=5043e453&scoped=true&"
import script from "./Survey2.vue?vue&type=script&lang=js&"
export * from "./Survey2.vue?vue&type=script&lang=js&"
import style0 from "./Survey2.vue?vue&type=style&index=0&id=5043e453&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5043e453",
  null
  
)

export default component.exports